import script from "./ReviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./ReviewPanel.vue?vue&type=style&index=0&id=a14a5844&lang=scss"

const __exports__ = script;

export default __exports__